import React from 'react';
import { FiAlertTriangle, FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const AlertBanner = ({ alert }) => {
  if (!alert) return null;

  return (
    <div className="bg-alert text-white px-4 py-3 relative shadow-md animate-pulse-slow">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between text-sm sm:text-base">
        <div className="flex items-center mb-2 sm:mb-0">
          <FiAlertTriangle className="text-xl mr-3 flex-shrink-0" />
          <span className="font-bold mr-2">BREAKING SAFETY ALERT:</span>
          <span className="line-clamp-1">{alert.title}</span>
        </div>
        <Link 
          to="/alerts" 
          className="flex items-center font-semibold underline hover:text-red-100 transition-colors whitespace-nowrap"
        >
          Read Full Report <FiArrowRight className="ml-1" />
        </Link>
      </div>
    </div>
  );
};

export default AlertBanner;